<template>
  <div>
    <v-dialog v-model="dialog" persistent width="1600">
      <v-card>
        <ModalHeader
          title="All Items"
          icon="mdi-package-variant"
          @close="dialog = false"
        />
        <v-card-text class="pa-4">
          <v-text-field outlined dense v-model="search"></v-text-field>
          <v-data-table
            :loading="loading"
            :items="all_items"
            :headers="all_items_headers"
            :search="search"
          >
            <!-- template for action column -->

            <template v-slot:item.item_name="{ item }">
              <span
                :class="
                  item.is_vat
                    ? 'green--text font-weight-bold'
                    : 'orange--text font-weight-bold'
                "
                >{{ item.item_name }}</span
              >
            </template>
            <template v-slot:item.is_deleted="{ item }">
              <v-btn
                text
                :color="item.is_deleted === 1 ? 'red' : 'primary'"
                small
                class="white--text"
                ><span v-if="item.is_deleted === 1">Deleted</span
                ><span v-else>Active</span></v-btn
              >
            </template>
            <template v-slot:item.action="{ item }">
              <div class="d-flex">
                <v-btn
                  class="ml-2"
                  v-if="can('items.restore')"
                  color="success"
                  @click="restore(item)"
                  small
                  icon
                  ><v-icon>mdi-refresh</v-icon></v-btn
                >
                <v-btn
                  class="ml-2"
                  v-if="can('items.delete')"
                  color="red"
                  @click="permanentDelete(item)"
                  small
                  icon
                  ><v-icon>mdi-delete-forever</v-icon></v-btn
                >
              </div>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="$emit('close')"> Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      search: "",
      dialog: true,
      loading: false,
      all_items_headers: [
        { text: "Action", value: "action", sortable: false },
        { text: "ID", value: "id" },
        { text: "Item Name", value: "item_name" },
        { text: "Unit Price", value: "unit_price" },
        { text: "Shipping Cost", value: "shipping_cost" },
        { text: "Selling Price", value: "selling_price" },
        { text: "Quantity", value: "quantity" },
        { text: "Supplier", value: "supplier" },
        {
          text: "Batch import",
          value: "import_batch.batch_description",
        },
        { text: "Date Arrived", value: "import_batch.date_arrived" },
        { text: "Branch", value: "branch.branch_name" },
        { text: "Status", value: "is_deleted" },
      ],
    };
  },
  methods: {
    // Hat-based permission gate; accounts without hats get no access.
    can(key) {
      return this.hasPermission(key);
    },
    submit() {},
    async restore(item) {
      let x = await this.$confirm({
        title: "Restore Item",
        message: "Are you sure you want to restore this item?",
        color: "primary",
        icon: "mdi-help-circle-outline",
      });
      if (x) {
        this.restore_item(item).then(() => {
          this.$alert({
            title: "Success",
            message: "Item restored",
            color: "success",
            icon: "mdi-check-circle",
          });
        });
      }
    },
    async permanentDelete(item) {
      let x = await this.$confirm({
        title: "Permanently Delete Item",
        message: `Are you sure you want to permanently delete "${item.item_name}"? This action cannot be undone.`,
        color: "red",
        icon: "mdi-delete-forever",
      });
      if (x) {
        this.force_delete_item(item.id).then(() => {
          this.$alert({
            title: "Success",
            message: "Item permanently deleted",
            color: "success",
            icon: "mdi-check-circle",
          });
        });
      }
    },
    ...mapActions({
      restore_item: "item/restore_item",
      force_delete_item: "item/force_delete_item",
      get_all_items: "item/get_all_items",
    }),
  },
  computed: {
    ...mapGetters({
      all_items: "item/all_items",
      user: "auth/user",
      hasPermission: "permission/hasPermission",
      user_permissions: "permission/user_permissions",
    }),
  },
  created() {
    if (this.all_items.length <= 0) {
      this.loading = true;
      this.get_all_items().then(() => {
        this.loading = false;
      });
    }
  },
};
</script>

<style lang="scss" scoped></style>
